<app-home-contact-us> </app-home-contact-us>
<!-- <section class="text-gray-600 body-font"> -->
  <section class="container mx-auto flex px-5 py-24 items-center justify-center flex-col text-gray-600 body-font">
    <p>
      Open Hours :
      <br>
      Monday to Saturday - 📂9.00 a.m to 7.00 p.m
      <br>

      Sunday - 📪Close
      <br>

      Poya day & Mercantile Holiday - 📂9.00 a.m to 12.30 p.m
    </p>
  </section>

<app-footer></app-footer>